import { Subscription } from 'rxjs';
import { OnDestroy, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ComponentHelper implements OnDestroy {
  private subs: Subscription[] = [];

  ngOnDestroy(): void {
    for (const sub of this.subs) {
      sub.unsubscribe();
    }
  }

  public addSub(sub: Subscription) {
    this.subs.push(sub);
  }
}
